import {
  GET_LIST_REQUEST_DEFAULT_LIMIT,
  PAGE_SEARCH_PARAMETER
} from "constants/common";
import { useManageTable } from "hooks";
/* eslint-disable react-hooks/exhaustive-deps */
import { useMemo } from "react";
import { useParams, useSearchParams } from "react-router-dom";

import {
  GetResellerReferralsRequestParams,
  useGetResellerReferrals
} from "../apis";
import {
  REFERRALS_ACTIVE_ONLY_SEARCH_PARAMETER,
  ResellerReferralsOrderBy
} from "../constants";

const useResellerReferralsList = () => {
  const { resellerId } = useParams();

  const {
    page,
    searchValue,
    debouncedSearch,
    sorting,
    setSorting,
    setSearchValue,
    setPage
  } = useManageTable({
    defaultSorting: [{ id: ResellerReferralsOrderBy.SignedUpAt, desc: true }]
  });

  const [searchParams, setSearchParams] = useSearchParams();

  const activeOnly =
    searchParams.get(REFERRALS_ACTIVE_ONLY_SEARCH_PARAMETER) === "true";

  const toggleActiveOnly = () => {
    if (activeOnly) {
      searchParams.delete(REFERRALS_ACTIVE_ONLY_SEARCH_PARAMETER);
    } else {
      searchParams.set(REFERRALS_ACTIVE_ONLY_SEARCH_PARAMETER, "true");
    }
    searchParams.delete(PAGE_SEARCH_PARAMETER);
    setSearchParams(searchParams);
  };

  const requestParams: GetResellerReferralsRequestParams = useMemo(
    () => ({
      page,
      take: GET_LIST_REQUEST_DEFAULT_LIMIT,
      search: debouncedSearch || undefined,
      orderBy:
        (sorting[0]?.id as ResellerReferralsOrderBy) ??
        ResellerReferralsOrderBy.SignedUpAt,
      order: sorting[0] ? (sorting[0]?.desc ? "DESC" : "ASC") : "DESC",
      activeOnly: activeOnly || undefined
    }),
    [page, debouncedSearch, sorting, activeOnly]
  );

  const { referrals, meta, summary, isLoading, isFetching } =
    useGetResellerReferrals(String(resellerId), requestParams);

  return {
    resellerId: String(resellerId),
    referrals,
    summary,
    totalItems: meta?.itemCount ?? 0,
    isLoading: isLoading || isFetching,
    page,
    setPage,
    searchValue,
    setSearchValue,
    sorting,
    setSorting,
    activeOnly,
    toggleActiveOnly
  };
};

export default useResellerReferralsList;
